import './ArticleMenu.less';

import clsx from 'clsx';
import * as React from 'react';
import { useLocation } from 'react-router-dom';

import { matchesMenuItemCondition, Menu, MenuFlags } from 'nike-ui/src/components/menu/Menu';
import { trackEvent } from 'nike-ui/src/analytics/gtm';
import LinkInterceptor from 'nike-ui/src/components/link-interceptor/LinkInterceptor';
import i18n from '@i18n';
import ArrowIcon from 'nike-ui/src/icons/svg/arrow-icon-sv.svg';
import { isLoggedIn } from '@/account';

interface ArticleMenuProps {
    menu?: Menu;
}

export const ArticleMenu = ({ menu }: ArticleMenuProps) => {
    if (!menu?.length) {
        return null;
    }
    return (
        <div className="article-menu">
            {menu.map(item => (
                <ArticleMenuItem
                    url={item.url}
                    key={item.url}
                    flags={item.flags}
                    label={i18n(item.key)}
                    data-atid={'menu-item:' + item.name}
                />
            ))}
        </div>
    );
};

interface ArticleMenuItemProps {
    label: string;
    url: string;
    flags?: MenuFlags[] | string[];
}

function ArticleMenuItem({ url, label, flags, ...rest }: ArticleMenuItemProps) {
    const location = useLocation();
    const active = location.pathname === url;

    const matches = matchesMenuItemCondition(flags, { loggedIn: isLoggedIn() });

    if (active || !matches) {
        return null;
    }

    return (
        <LinkInterceptor
            {...rest}
            className={clsx('article-menu-item article-box', { active })}
            href={url}
            onClick={() => trackEvent('Menu', url)}
        >
            <span className="title">{label}</span>
            <span>
                <ArrowIcon />
            </span>
        </LinkInterceptor>
    );
}
